import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import { LTR, fmtClock } from "../utils";

function Row({ label, value }) {
  return (
    <Stack direction="row" justifyContent="space-between" spacing={2} useFlexGap>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, ...LTR, fontVariantNumeric: "tabular-nums" }}
      >
        {value}
      </Typography>
    </Stack>
  );
}

export default function ConfirmGenerateDialog({
  open,
  show,
  range,
  submitting,
  blocked,
  onCancel,
  onConfirm,
  text,
}) {
  return (
    <Dialog open={open} onClose={submitting ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{text.confirm.title}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1}>
          <Row label={text.confirm.show} value={show.title || text.untitled} />
          <Row label={text.start} value={fmtClock(range[0])} />
          <Row label={text.end} value={fmtClock(range[1])} />
          <Row label={text.length} value={fmtClock(range[1] - range[0])} />
          <Typography variant="body2" sx={{ pt: 1, color: "text.secondary" }}>
            {text.confirm.body}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          {text.confirm.cancel}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          // Re-checked here, not just on the button that opened this: the range
          // can still change underneath an open dialog.
          disabled={submitting || blocked}
          startIcon={
            submitting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <AutoAwesomeRoundedIcon fontSize="small" />
            )
          }
        >
          {text.confirm.ok}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
